"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGetAggregatedProductMeasures = void 0;
const react_1 = require("react");
const react_2 = require("@apollo/client/react");
const graphql_1 = require("../../../../__generated__/graphql");
const client_constants_1 = require("../../client.constants");
const client_utils_1 = require("../../client.utils");
const hooks_1 = require("../../hooks");
const constants_1 = require("../constants");
const gql_1 = require("../gql");
const models_1 = require("../../../models");
// merge the new part with an already loaded
const updateQuery = (previousResult, options) => {
    var _a, _b;
    const { edges: prevMeasures = [] } = (_a = previousResult.productTreeNode.productAggregatedMeasures) !== null && _a !== void 0 ? _a : {};
    const { productTreeNode } = (_b = options === null || options === void 0 ? void 0 : options.fetchMoreResult) !== null && _b !== void 0 ? _b : {};
    const _c = productTreeNode.productAggregatedMeasures, { edges = [] } = _c, productMeasuresData = __rest(_c, ["edges"]);
    return {
        productTreeNode: Object.assign(Object.assign(Object.assign({}, previousResult.productTreeNode), productTreeNode), { productAggregateMeasures: Object.assign(Object.assign({}, productMeasuresData), { edges: [...prevMeasures, ...edges] }) }),
    };
};
const fetchMoreOptions = { updateQuery };
/**
 *
 * @returns aggregated text attributes for the selected node and all its children.
 */
const useGetAggregatedProductMeasures = ({ productTreeNodeId, sortingItem = models_1.SortingItem.SortByTextAsc, pageSize = client_constants_1.PAGE_SIZE_LARGE, options, filter, catalogId, }) => {
    var _a, _b;
    const sort = constants_1.sortingItemToAggregatedProductMeasuresSortMap[sortingItem];
    const { data, previousData, error, networkStatus, variables, fetchMore, refetch, } = (0, react_2.useQuery)(gql_1.GET_AGGREGATED_PRODUCT_MEASURES, {
        notifyOnNetworkStatusChange: true,
        variables: {
            catalogId,
            productTreeNodeId: productTreeNodeId !== null && productTreeNodeId !== void 0 ? productTreeNodeId : '',
            sort,
            filter,
            first: pageSize,
            before: null,
            after: null,
            last: null,
        },
        skip: !productTreeNodeId || (options === null || options === void 0 ? void 0 : options.skip),
    });
    const { pageInfo, edges } = (_a = data === null || data === void 0 ? void 0 : data.productTreeNode.productAggregatedMeasures) !== null && _a !== void 0 ? _a : {};
    const { hasNextPage } = pageInfo !== null && pageInfo !== void 0 ? pageInfo : {};
    const pagination = (0, hooks_1.usePagination)({
        networkStatus,
        pageInfo,
        pageSize,
        fetchMore,
        fetchMoreOptions,
        lastVariables: variables,
    });
    const onRefetch = (0, react_1.useCallback)((newVariables) => refetch(Object.assign(Object.assign({}, newVariables), { first: pageSize, before: null, after: null, last: null })), [pageSize, refetch]);
    const onSearch = (0, react_1.useCallback)((searchString) => onRefetch({
        filter: {
            some: {
                dimension: {
                    contains: searchString.trim(),
                    mode: graphql_1.StringFilterMode.Insensitive,
                },
            },
        },
    }), [onRefetch]);
    return {
        data: edges,
        previousData: (_b = previousData === null || previousData === void 0 ? void 0 : previousData.productTreeNode.productAggregatedMeasures) === null || _b === void 0 ? void 0 : _b.edges,
        isLoading: (0, client_utils_1.isQueryLoadingOrRefetching)(networkStatus),
        isRefetching: (0, client_utils_1.isQueryRefetching)(networkStatus),
        pagination,
        error,
        hasNextPage,
        refetch: onRefetch,
        onSearch,
    };
};
exports.useGetAggregatedProductMeasures = useGetAggregatedProductMeasures;
